import { render, staticRenderFns } from "./main-lot-table.vue?vue&type=template&id=d886b134"
import script from "./main-lot-table.vue?vue&type=script&lang=js"
export * from "./main-lot-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports